function before() {

    // console.log('lifecycle :', 'before loading scene');
}

export {before};
